import React from "react";
import { Spinner } from "../../../../common/spinner";
import Util from "../../../../../util/util";
import { DiscoverConstants } from "../../../../../configurations/discoverConfigs/discoverConstants";
import { Link } from "react-router";
import routesConfig from "../../../../../configurations/routesConfig";
const Response = ({ sending, errors, caseSuccessfulResponse }) => (
  <div>
    {sending && (
      <div className="text-center">
        <Spinner size="150px" message="Initiating a case..." />
      </div>
    )}
    {errors === "" && (
      <h4 className="text-danger bold">Something went wrong</h4>
    )}
    {errors && (
      <div>
        {!errors.errors && (
          <h4 className="bold text-danger">
            Error: {errors.description || errors.responseMessage}
          </h4>
        )}

        {errors.errors &&
          errors.errors.map((error, index) => (
            <div key={index} className="panel panel-default">
              <div className="panel-body">
                <p>
                  <strong>
                    {error.fieldName && Util.camelToSentence(error.fieldName)}:
                  </strong>{" "}
                  {error.message}
                </p>
              </div>
            </div>
          ))}
      </div>
    )}
    {caseSuccessfulResponse && (
      <div className="alert alert-success">
        {caseSuccessfulResponse.code ===
          DiscoverConstants.CaseCreationStatuses.case_created && (
          <div>
            <h4 className="bold">Case created successfully</h4>
            <p>{caseSuccessfulResponse.description}</p>
            <p>
              <Link
                to={routesConfig.DISCOVER_CASES_ROUTE.path}
                className="btn btn-success"
              >
                View Cases
              </Link>
            </p>
          </div>
        )}
        {caseSuccessfulResponse.code ===
          DiscoverConstants.CaseCreationStatuses.case_request_submitted && (
          <div>
            <h4 className="bold">Case submitted successfully</h4>
            <p>{caseSuccessfulResponse.description}</p>
            <p>
              <Link
                to={routesConfig.DISCOVER_CASESREQUEST_ROUTE.path}
                className="btn btn-success"
              >
                View Case Requests
              </Link>
            </p>
          </div>
        )}
      </div>
    )}
  </div>
);

export default Response;



// WEBPACK FOOTER //
// ./src/components/discover/newCase/transactionDetail/CreateCaseForms/Response.js